import type { FaireProductEntity } from "../../entity_types/product";

export const p_p7y93umbzy: FaireProductEntity = {
  token: "p_p7y93umbzy",
  type: "product",
  name: "Albion Soulstice Yoga Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/8f0046b40b3dab8c0809465c607b1c43e89913f2b85bf54534f89c6088671608.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e78e5508332cd1d417b84f5f7b39ea085326d6c2fb3a84ed9e442c84d4dcf70.jpeg",
    "https://cdn.faire.com/fastly/fb7455107c8f46630317b142eb183ed415911c9421bc0aebcb47e28a2ada3ba3.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:54.275Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
